// extracted by mini-css-extract-plugin
export default {"cls1":"NewUserDiscountButton-cls1___903e29c5c400cd13815","cls2":"NewUserDiscountButton-cls2__dbaea495a41db01622c8 NewUserDiscountButton-cls1___903e29c5c400cd13815"};